import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import ReactCountryFlag from 'react-country-flag';
import { IMenuItem } from 'types/menu';
import { CourseWithModules, generateMenuItemId } from './utils';
import { LANGUAGE_FLAGS } from './constants';
import {
  LanguageGroup,
  LanguageHeader,
  FlagWrapper,
  LanguageTitle,
  CourseList,
  CourseItemWrapper,
  CourseItem,
  CourseTitle,
  ModuleCount,
} from './styles';

interface Props {
  language: string;
  courses: CourseWithModules[];
  onCourseHover: (
    e: React.MouseEvent<HTMLDivElement>,
    course: IMenuItem,
    modules: IMenuItem[],
    language: string,
  ) => void;
  onCourseLeave: () => void;
  collapsed?: boolean;
  onToggle?: (language: string) => void;
}

export const LanguageSection: React.FC<Props> = ({ language, courses, onCourseHover, onCourseLeave, collapsed = true, onToggle }) => {
  if (courses.length === 0) return null;

  // Sort courses alphabetically
  const sortedCourses = courses.sort((a, b) =>
    a.course.title.localeCompare(b.course.title, undefined, { sensitivity: 'base' }),
  );

  return (
    <LanguageGroup>
      <LanguageHeader onClick={() => onToggle && onToggle(language)}>
        <FlagWrapper>
          <ReactCountryFlag
            countryCode={LANGUAGE_FLAGS[language] || 'XX'}
            svg
            style={{
              width: '18px',
              height: '12px',
            }}
          />
        </FlagWrapper>
        <LanguageTitle>{language.toUpperCase()}</LanguageTitle>
        <FontAwesomeIcon
          icon={faChevronRight}
          size="xs"
          style={{
            color: '#8b92a8',
            transform: collapsed ? 'rotate(0deg)' : 'rotate(90deg)',
            transition: 'transform 0.15s ease-in-out',
            marginLeft: 6,
          }}
        />
      </LanguageHeader>

      {!collapsed && (
      <CourseList>
        {sortedCourses.map(({ course, modules }) => {
          const courseKey = generateMenuItemId(course);

          return (
            <CourseItemWrapper
              key={courseKey}
              onMouseEnter={(e) => {
                if (modules.length > 0) {
                  onCourseHover(e, course, modules, language);
                }
              }}
              onMouseLeave={onCourseLeave}
            >
              <CourseItem hasModules={modules.length > 0}>
                <CourseTitle>{course.title}</CourseTitle>
                {modules.length > 0 && <ModuleCount>{modules.length}</ModuleCount>}
              </CourseItem>
            </CourseItemWrapper>
          );
        })}
      </CourseList>
      )}
    </LanguageGroup>
  );
};
